<template>

<core-card-foot-item>

	<app-view-common-disparity :value="item.rating.rating" :average="item.game.rating_avg" class="card-stats-item-disparity" v-if="isUser" />
	<app-view-common-disparity :value="item.group.rating_avg" :average="item.game.rating_avg" class="card-stats-item-disparity" v-if="!isUser" />

	<core-card-foot-item-label>{{ field.label }}</core-card-foot-item-label>

</core-card-foot-item>

</template>

<script>

export default {

	props: ['item', 'field']

}

</script>

<style scoped>

</style>
